import PropTypes from 'prop-types';
import { BsGeoAlt } from 'react-icons/bs';

import Card from '#globalComponents/Card/Card';

import { formatEuro } from '../../../utils/formatters';

const CompanyHeader = ({ company, openDeals, pipelineValue, ownerMember }) => (
	<Card className="mb-4 overflow-hidden p-0">
		<div className="grid items-center gap-4 px-5 py-4" style={{ gridTemplateColumns: '56px 1fr auto' }}>
			<div className="w-14 h-14 rounded-card bg-gradient-to-br from-primary-500 to-primary-600 text-white flex items-center justify-center text-lg-bold tracking-tight">
				{company.companyName
					?.split(' ')
					.map((n) => n[0])
					.slice(0, 2)
					.join('') ?? '?'}
			</div>
			<div className="min-w-0">
				<h1 className="text-lg-bold text-text tracking-tight truncate">{company.companyName}</h1>
				<div className="flex items-center gap-1.5 flex-wrap mt-1 text-xs text-bgBase-800">
					{company.addressCity && (
						<>
							<BsGeoAlt className="w-2.5 h-2.5 text-bgBase-800" />
							<span>{company.addressCity}</span>
							<span className="text-bgBase-800">·</span>
						</>
					)}
					{company.websiteUrl && (
						<a
							href={
								company.websiteUrl.startsWith('http')
									? company.websiteUrl
									: `https://${company.websiteUrl}`
							}
							className="text-primary-600 hover:text-primary-700 truncate max-w-[200px]"
							target="_blank"
							rel="noopener noreferrer"
						>
							{company.websiteUrl}
						</a>
					)}
				</div>
			</div>
			<div className="flex gap-4 lg:gap-7 pl-4 lg:pl-6 border-l border-bgBase-500 flex-shrink-0">
				<div className="flex flex-col gap-1">
					<span className="text-xs-head text-bgBase-800">Offene Deals</span>
					<span className="text-lg-bold text-text tabular-nums">{openDeals.length}</span>
				</div>
				<div className="flex flex-col gap-1">
					<span className="text-xs-head text-bgBase-800">Pipeline-Wert</span>
					<span className="text-lg-bold text-text tabular-nums">{formatEuro(pipelineValue)}</span>
				</div>
				{ownerMember && (
					<div className="flex flex-col gap-1">
						<span className="text-xs-head text-bgBase-800">Owner</span>
						<span className="text-lg-bold text-text">
							{ownerMember.fullName?.split(' ')[0] ?? ownerMember.email}
						</span>
					</div>
				)}
			</div>
		</div>
	</Card>
);

CompanyHeader.propTypes = {
	company: PropTypes.object.isRequired,
	openDeals: PropTypes.array.isRequired,
	pipelineValue: PropTypes.number.isRequired,
	ownerMember: PropTypes.object,
};

export default CompanyHeader;
